import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  ValidationRule,
  InputType,
} from "../services/types/ComponentTypes";

export const screen_116_add_estimate: any[] = [
            {
                "componentType": "screenGroup",
                "title": "Add Estimate",
                "style": {},
                "childComponents": [
                    {
                        "componentType": "form",
                        "Name": "estimation_add",
                        "columnNumber": "m1 t1 w1",
                        "TableName": "service_estimation",
                        "Workflow": "service",
                        "DisplayName": "Vehicle estimation",
                        "formActions": [
                            {
                                "name": "lock",
                                "icon": "lock",
                                "onPressAction": "unlock"
                            },
                            {
                                "name": "Print",
                                "icon": "print",
                                "settings": "Estimation",
                                "onPressAction": "pdf"
                            }
                        ],
                        "style": {
                            "backgroundColor": "#ffffff",
                            "direction": "column",
                            "padding": 10
                        },
                        "Fields": [
                            {
                                "componentType": "group",
                                "Label": "",
                                "BindValue": "cont_Action",
                                "style": {
                                    "direction": "row",
                                    "padding": 0,
                                    "margin": 0,
                                    "marginBottom": 8
                                }
                            },
                            {
                                "componentType": "fieldGroup",
                                "Label": "Estimate details",
                                "BindValue": "con_estimate_details",
                                "style": {
                                    "direction": "column"
                                },
                                "childComponents": [
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Estimate No.",
                                        "PlaceHolder": "Will be auto generated...",
                                        "IsMandatory": false,
                                        "BindValue": "txt_estimate_number",
                                        "Json_Attribute": "est_no",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "AutoPopulate": true,
                                        "IsReadOnly": true,
                                        "AutoPopulate_format": "EST_[******]",
                                        "IsVerticalView": true,
                                        "inputType": "text"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Estimation date",
                                        "PlaceHolder": "",
                                        "IsMandatory": true,
                                        "BindValue": "dt_est_date",
                                        "Json_Attribute": "est_date",
                                        "componentType": "dateField",
                                        "showInSummary": false,
                                        "IsVerticalView": true,
                                        "DefaultToday": true,
                                        "maxDate": "today"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Inspection No.",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "parentid",
                                        "Json_Attribute": "parent_id",
                                        "componentType": "searchableDropdown",
                                        "AutoSelect": "parentid",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "LookupName": "inspection_items",
                                        "IsVerticalView": true
                                    },
                                    {
                                        "Label": "",
                                        "BindValue": "veh_details",
                                        "componentType": "report",
                                        "IncludeLabel": true,
                                        "Settings": "Vehicle_details",
                                        "Parent_Field": "parentid"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Remarks",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_remarks",
                                        "Json_Attribute": "remarks",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsVerticalView": true,
                                        "inputType": "text"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Estimated days",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_estimated_days",
                                        "Json_Attribute": "est_days",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsVerticalView": true,
                                        "inputType": "number",
                                        "validation": [
                                            {
                                                "rule": "pattern",
                                                "value": "^(?:0|[1-9][0-9]?|[12][0-9]{2}|3[0-5][0-9]|36[0-5])$",
                                                "message": "Value must be between 0 and 365"
                                            }
                                        ]
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Complaints",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "customer_remarks",
                                        "Json_Attribute": "customer_remarks",
                                        "componentType": "textArea",
                                        "showInSummary": true,
                                        "IsReadOnly": true,
                                        "IsVerticalView": true,
                                        "inputType": "text"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Emirates Id 1",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "emirates_id_1_others",
                                        "Json_Attribute": "emirates_id_1_attachment",
                                        "componentType": "files",
                                        "showInSummary": false,
                                        "IsVerticalView": true
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Emirates Id 2",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "emirates_id_2",
                                        "Json_Attribute": "emirates_id_2_attachment",
                                        "componentType": "files",
                                        "showInSummary": false,
                                        "IsVerticalView": true
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Police report",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "police_report",
                                        "Json_Attribute": "police_report_attachment",
                                        "componentType": "files",
                                        "showInSummary": false,
                                        "IsVerticalView": true
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Driving license",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "driving_license_attachment",
                                        "Json_Attribute": "driving_license_attachment",
                                        "componentType": "files",
                                        "showInSummary": false,
                                        "IsVerticalView": true
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Others",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "file_others",
                                        "Json_Attribute": "others_attachment",
                                        "componentType": "files",
                                        "showInSummary": false,
                                        "IsVerticalView": true
                                    }
                                ]
                            },
                            {
                                "componentType": "subModule",
                                "Label": "Spare parts",
                                "TableName": "service_spare_est_req",
                                "Name": "service_spare_est_req",
                                "BindValue": "sub_Checklist",
                                "childControls": [
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Code",
                                        "PlaceHolder": "",
                                        "IsMandatory": true,
                                        "BindValue": "drp_code",
                                        "Json_Attribute": "codeid",
                                        "componentType": "searchableDropdown",
                                        "showInSummary": false,
                                        "LookupName": "product_itemcode",
                                        "IsVerticalView": true
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Narration",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_narration",
                                        "Json_Attribute": "narration",
                                        "componentType": "textArea",
                                        "showInSummary": false,
                                        "IsVerticalView": true,
                                        "inputType": "text"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Qty",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_qty",
                                        "Json_Attribute": "req_qty",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsVerticalView": true,
                                        "inputType": "number",
                                        "Default_Value": "1"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Rate",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_rate",
                                        "Json_Attribute": "rate",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": false,
                                        "ForceExpressionUpdate": true,
                                        "IsVerticalView": true,
                                        "inputType": "number",
                                        "Default_Value": "0"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Amount",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_amount",
                                        "Json_Attribute": "amount",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "ExpressionV2": "[txt_rate] * [txt_qty]",
                                        "IsVerticalView": true,
                                        "inputType": "number",
                                        "Default_Value": "0"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "VAT%",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "drp_vat",
                                        "Json_Attribute": "vat_id",
                                        "componentType": "selectDropdown",
                                        "showInSummary": false,
                                        "LookupName": "tax_rates",
                                        "IncludeNotSet": false,
                                        "Default_Value": "1",
                                        "IsVerticalView": true
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "VAT amount",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_vat_amt",
                                        "Json_Attribute": "vat_amt",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "ExpressionV2": "[txt_amount] * ([drp_vat.taxrate]/100)",
                                        "IsVerticalView": true,
                                        "inputType": "number",
                                        "Default_Value": "0"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Net amount",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_net_amt",
                                        "Json_Attribute": "net_amt",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "ExpressionV2": "[txt_amount] + [txt_vat_amt]",
                                        "IsVerticalView": true,
                                        "inputType": "number",
                                        "Default_Value": "0"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Department",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "drp_department",
                                        "Json_Attribute": "department_id",
                                        "componentType": "selectDropdown",
                                        "showInSummary": false,
                                        "LookupName": "department",
                                        "IsVerticalView": true
                                    }
                                ],
                                "FooterControls": [
                                    {
                                        "componentType": "textField",
                                        "BindValue": "txt_one",
                                        "IncludeLabel": false,
                                        "IsReadOnly": true,
                                        "style": {
                                            "display": "none"
                                        }
                                    },
                                    {
                                        "componentType": "textField",
                                        "BindValue": "txt_2",
                                        "IncludeLabel": false,
                                        "IsReadOnly": true,
                                        "style": {
                                            "display": "none"
                                        }
                                    },
                                    {
                                        "componentType": "textField",
                                        "BindValue": "txt_3",
                                        "IncludeLabel": false,
                                        "IsReadOnly": true,
                                        "style": {
                                            "display": "none"
                                        }
                                    },
                                    {
                                        "IncludeLabel": false,
                                        "Label": "Amount",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_sub_amount",
                                        "Json_Attribute": "spare_amount",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "ExpressionV2": "[SUM:txt_amount]",
                                        "IsVerticalView": true,
                                        "inputType": "number",
                                        "Default_Value": "0"
                                    },
                                    {
                                        "componentType": "textField",
                                        "BindValue": "txt_6",
                                        "IncludeLabel": false,
                                        "IsReadOnly": true,
                                        "style": {
                                            "display": "none"
                                        }
                                    },
                                    {
                                        "IncludeLabel": false,
                                        "Label": "VAT Amount",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "spare_vat_amount",
                                        "Json_Attribute": "spare_vat_amount",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "ExpressionV2": "[SUM:txt_vat_amt]",
                                        "IsVerticalView": true,
                                        "inputType": "number",
                                        "Default_Value": "0"
                                    },
                                    {
                                        "IncludeLabel": false,
                                        "Label": "Net Amount",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_sub_net_amount",
                                        "Json_Attribute": "spare_net_amount",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "ExpressionV2": "[SUM:txt_net_amt]",
                                        "IsVerticalView": true,
                                        "inputType": "number",
                                        "Default_Value": "0"
                                    },
                                    {
                                        "componentType": "textField",
                                        "BindValue": "txt_8",
                                        "IncludeLabel": false,
                                        "IsReadOnly": true,
                                        "style": {
                                            "display": "none"
                                        }
                                    }
                                ]
                            },
                            {
                                "componentType": "subModule",
                                "Label": "Labour /Others",
                                "TableName": "service_labour_est",
                                "Name": "service_labour_est",
                                "BindValue": "sub_labour",
                                "childControls": [
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Code",
                                        "PlaceHolder": "",
                                        "IsMandatory": true,
                                        "BindValue": "drp_code",
                                        "Json_Attribute": "codeid",
                                        "componentType": "searchableDropdown",
                                        "showInSummary": false,
                                        "LookupName": "itemcode",
                                        "IsVerticalView": true
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Narration",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_narration",
                                        "Json_Attribute": "narration",
                                        "componentType": "textArea",
                                        "showInSummary": false,
                                        "IsVerticalView": true,
                                        "inputType": "text"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Qty",
                                        "PlaceHolder": "",
                                        "IsMandatory": true,
                                        "BindValue": "txt_qty",
                                        "Json_Attribute": "qty",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsVerticalView": true,
                                        "inputType": "number",
                                        "Default_Value": "1"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Rate",
                                        "PlaceHolder": "",
                                        "IsMandatory": true,
                                        "BindValue": "txt_rate",
                                        "Json_Attribute": "rate",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": false,
                                        "ForceExpressionUpdate": true,
                                        "IsVerticalView": true,
                                        "inputType": "number",
                                        "Default_Value": "0"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Amount",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_amount",
                                        "Json_Attribute": "amount",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "ExpressionV2": "[txt_rate] * [txt_qty]",
                                        "IsVerticalView": true,
                                        "inputType": "number",
                                        "Default_Value": "0"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "VAT%",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "drp_vat",
                                        "Json_Attribute": "vat_id",
                                        "componentType": "selectDropdown",
                                        "showInSummary": false,
                                        "LookupName": "tax_rates",
                                        "IncludeNotSet": false,
                                        "Default_Value": "1",
                                        "IsVerticalView": true
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "VAT amount",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_vat_amt",
                                        "Json_Attribute": "vat_amt",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "ExpressionV2": "[txt_amount] * ([drp_vat.taxrate]/100)",
                                        "IsVerticalView": true,
                                        "inputType": "number",
                                        "Default_Value": "0"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Net amount",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_net_amt",
                                        "Json_Attribute": "net_amt",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "ExpressionV2": "[txt_amount] + [txt_vat_amt]",
                                        "IsVerticalView": true,
                                        "inputType": "number",
                                        "Default_Value": "0"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Department",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "drp_department",
                                        "Json_Attribute": "department_id",
                                        "componentType": "selectDropdown",
                                        "showInSummary": true,
                                        "LookupName": "department",
                                        "IsVerticalView": true
                                    }
                                ],
                                "FooterControls": [
                                    {
                                        "componentType": "textField",
                                        "BindValue": "txt_2",
                                        "IncludeLabel": false,
                                        "IsReadOnly": true,
                                        "style": {
                                            "display": "none"
                                        }
                                    },
                                    {
                                        "componentType": "textField",
                                        "BindValue": "txt_3",
                                        "IncludeLabel": false,
                                        "IsReadOnly": true,
                                        "style": {
                                            "display": "none"
                                        }
                                    },
                                    {
                                        "componentType": "textField",
                                        "BindValue": "txt_4",
                                        "IncludeLabel": false,
                                        "IsReadOnly": true,
                                        "style": {
                                            "display": "none"
                                        }
                                    },
                                    {
                                        "IncludeLabel": false,
                                        "Label": "Amount",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_sub_amount",
                                        "Json_Attribute": "labour_amount",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "ExpressionV2": "[SUM:txt_amount]",
                                        "IsVerticalView": true,
                                        "inputType": "number",
                                        "Default_Value": "0"
                                    },
                                    {
                                        "componentType": "textField",
                                        "BindValue": "txt_7",
                                        "IncludeLabel": false,
                                        "IsReadOnly": true,
                                        "style": {
                                            "display": "none"
                                        }
                                    },
                                    {
                                        "IncludeLabel": false,
                                        "Label": "VAT Amount",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "labour_vat_amount",
                                        "Json_Attribute": "labour_vat_amount",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "ExpressionV2": "[SUM:txt_vat_amt]",
                                        "IsVerticalView": true,
                                        "inputType": "number",
                                        "Default_Value": "0"
                                    },
                                    {
                                        "IncludeLabel": false,
                                        "Label": "Net Amount",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_sub_net_amount",
                                        "Json_Attribute": "labour_net_amount",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "ExpressionV2": "[SUM:txt_net_amt]",
                                        "IsVerticalView": true,
                                        "inputType": "number",
                                        "Default_Value": "0"
                                    },
                                    {
                                        "componentType": "textField",
                                        "BindValue": "txt_8",
                                        "IncludeLabel": false,
                                        "IsReadOnly": true,
                                        "style": {
                                            "display": "none"
                                        }
                                    }
                                ]
                            },
                            {
                                "componentType": "subModule",
                                "Label": "Miscellaneous",
                                "TableName": "estimation_miscellaneous",
                                "Name": "estimation_miscellaneous",
                                "BindValue": "sub_miscellaneous",
                                "LookupName": "",
                                "Parent_Field": "parentid",
                                "childControls": [
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Item type",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "drp_item_type",
                                        "Json_Attribute": "item_type",
                                        "componentType": "selectDropdown",
                                        "showInSummary": false,
                                        "LookupName": "item_type",
                                        "IsVerticalView": true
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Code",
                                        "PlaceHolder": "",
                                        "IsMandatory": true,
                                        "BindValue": "txt_code",
                                        "Json_Attribute": "codeid",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": false,
                                        "IsVerticalView": true,
                                        "inputType": "text"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Item name",
                                        "PlaceHolder": "",
                                        "IsMandatory": true,
                                        "BindValue": "item_name",
                                        "Json_Attribute": "item_name",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": false,
                                        "IsVerticalView": true,
                                        "inputType": "text"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Qty",
                                        "PlaceHolder": "",
                                        "IsMandatory": true,
                                        "BindValue": "txt_qty",
                                        "Json_Attribute": "qty",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsVerticalView": true,
                                        "inputType": "number",
                                        "Default_Value": "1"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Rate",
                                        "PlaceHolder": "",
                                        "IsMandatory": true,
                                        "BindValue": "txt_rate",
                                        "Json_Attribute": "rate",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": false,
                                        "IsVerticalView": true,
                                        "inputType": "number"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Amount",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_amount",
                                        "Json_Attribute": "amount",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "ExpressionV2": "[txt_rate] * [txt_qty]",
                                        "IsVerticalView": true,
                                        "inputType": "number",
                                        "Default_Value": "0"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "VAT%",
                                        "PlaceHolder": "",
                                        "IsMandatory": true,
                                        "BindValue": "drp_vat",
                                        "Json_Attribute": "vat_id",
                                        "componentType": "selectDropdown",
                                        "showInSummary": false,
                                        "LookupName": "tax_rates",
                                        "IncludeNotSet": false,
                                        "Default_Value": "1",
                                        "IsVerticalView": true
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "VAT amount",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_vat_amt",
                                        "Json_Attribute": "vat_amt",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "ExpressionV2": "[txt_amount] * ([drp_vat.taxrate]/100)",
                                        "IsVerticalView": true,
                                        "inputType": "number",
                                        "Default_Value": "0"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Net amount",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_net_amt",
                                        "Json_Attribute": "net_amt",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "ExpressionV2": "[txt_amount] + [txt_vat_amt]",
                                        "IsVerticalView": true,
                                        "inputType": "number",
                                        "Default_Value": "0"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Department",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "drp_department",
                                        "Json_Attribute": "department_id",
                                        "componentType": "selectDropdown",
                                        "showInSummary": false,
                                        "LookupName": "department",
                                        "IsVerticalView": true
                                    }
                                ],
                                "FooterControls": [
                                    {
                                        "componentType": "textField",
                                        "BindValue": "txt_7",
                                        "IncludeLabel": false,
                                        "IsReadOnly": true,
                                        "style": {
                                            "display": "none"
                                        }
                                    },
                                    {
                                        "componentType": "textField",
                                        "BindValue": "txt_7",
                                        "IncludeLabel": false,
                                        "IsReadOnly": true,
                                        "style": {
                                            "display": "none"
                                        }
                                    },
                                    {
                                        "componentType": "textField",
                                        "BindValue": "txt_9",
                                        "IncludeLabel": false,
                                        "IsReadOnly": true,
                                        "style": {
                                            "display": "none"
                                        }
                                    },
                                    {
                                        "componentType": "textField",
                                        "BindValue": "txt_8",
                                        "IncludeLabel": false,
                                        "IsReadOnly": true,
                                        "style": {
                                            "display": "none"
                                        }
                                    },
                                    {
                                        "componentType": "textField",
                                        "BindValue": "txt_10",
                                        "IncludeLabel": false,
                                        "IsReadOnly": true,
                                        "style": {
                                            "display": "none"
                                        }
                                    },
                                    {
                                        "IncludeLabel": false,
                                        "Label": "Amount",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_sub_amount",
                                        "Json_Attribute": "miscellaneous_amount",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "ExpressionV2": "[SUM:txt_amount]",
                                        "IsVerticalView": true,
                                        "inputType": "number",
                                        "Default_Value": "0"
                                    },
                                    {
                                        "componentType": "textField",
                                        "BindValue": "txt_8",
                                        "IncludeLabel": false,
                                        "IsReadOnly": true,
                                        "style": {
                                            "display": "none"
                                        }
                                    },
                                    {
                                        "IncludeLabel": false,
                                        "Label": "VAT Amount",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "miscellanious_vat_amount",
                                        "Json_Attribute": "miscellanious_vat_amount",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "ExpressionV2": "[SUM:txt_vat_amt]",
                                        "IsVerticalView": true,
                                        "inputType": "number",
                                        "Default_Value": "0"
                                    },
                                    {
                                        "IncludeLabel": false,
                                        "Label": "Net Amount",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_sub_net_amount",
                                        "Json_Attribute": "miscellaneous_net_amount",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "ExpressionV2": "[SUM:txt_net_amt]",
                                        "IsVerticalView": true,
                                        "inputType": "number",
                                        "Default_Value": "0"
                                    }
                                ]
                            },
                            {
                                "componentType": "fieldGroup",
                                "columnNumber": "m1 t2 w3",
                                "BindValue": "cont_total_amount",
                                "childComponents": [
                                    {
                                        "IncludeLabel": true,
                                        "Label": "VAT amount",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "gross_vat_amount",
                                        "Json_Attribute": "gross_vat_amount",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "ExpressionV2": "[(service_spare_est_req).spare_vat_amount] + [(service_labour_est).labour_vat_amount]+[(estimation_miscellaneous).miscellanious_vat_amount]",
                                        "IsVerticalView": true,
                                        "inputType": "number",
                                        "Default_Value": "0"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Discount",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_discount",
                                        "Json_Attribute": "discount",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": false,
                                        "IsVerticalView": true,
                                        "inputType": "number",
                                        "Default_Value": "0"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Gross amount",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "gross_amount",
                                        "Json_Attribute": "gross_amount",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "ExpressionV2": "[(service_spare_est_req).txt_sub_amount] + [(service_labour_est).txt_sub_amount]+[(estimation_miscellaneous).txt_sub_amount]",
                                        "IsVerticalView": true,
                                        "inputType": "number",
                                        "Default_Value": "0"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Total amount",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_total_amount",
                                        "Json_Attribute": "est_total_amount",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "ExpressionV2": "[(service_spare_est_req).txt_sub_net_amount] + [(service_labour_est).txt_sub_net_amount]+[(estimation_miscellaneous).txt_sub_net_amount] - [txt_discount]",
                                        "IsVerticalView": true,
                                        "inputType": "number",
                                        "Default_Value": "0",
                                        "validation": [
                                            {
                                                "rule": "pattern",
                                                "value": "^[0-9]+(\\.[0-9]+)?$",
                                                "message": "Total amount cannot be negative. Please adjust the discount."
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "componentType": "button",
                        "formName": "estimation_add",
                        "next_action": "Estimate",
                        "next_state": "Estimated",
                        "name": "Save",
                        "onPressAction": "save"
                    }
                ]
            }
        ];
